import React, { useRef, useState } from "react";
import "./Task.css";

import { Container, Row, Col } from "reactstrap";
import { Label } from "@progress/kendo-react-labels";

import heroImg from "../../assests/images/hero-img1.png";
import TaskCard from "./TaskCard";


const taskdata = [
    {
        task_id: "1",
        content_title: `Симметрия тұрғысынан алып қарағанда өріс кернеулігінің векторы, суретте көрсетілгендей, центрден сақина осьі бойымен бағытталады. Өйткені ху жазықтығы бойында диаметральді орналасқан  λdl  элементар зарядтар беретін Ex, Ey құраушылары жұптап компенсацияланады, яғни   Ez = E. Сақина заряды мынаған тең q=λ2πR.   dq=λdl элементар зарядынан dEz табамыз және төмендегі өрнекті аламыз`,
        id_faq: "faq_1",
        for_faq: "faq_1",
        question: `Радиусы 0,1 м жұқа сақина q = 1,03 мкКл зарядпен бірқалыпты зарядталған.
        Өріс кернеулігін анықтаңыз: 1) сақина центрі арқылы өтетін және оның жазықтығына перпендикуляр болатын келетін, осьтің бойындағы оның центрінен z=0,1м қашықтықтағы нүктедегі; 2) сақина центріндегі; 3) сақина центрінен осы ось бойында қандай қашықтықта өріс кернеулігі максималь мәнге ие болады?
        `,
        img_url: heroImg,
        answers: `#Сақина алаңы
        import math
        import matplotlib.pyplot as plt
        eps0=8.85e-12; k0=1/(4*math.pi*eps0);
        NZ=1000; R=0.1; q=1.03e-6;
        def f(z):
          f = k0 * q * z / (R * R + z * z) ** 1.5;
          return f
        z0=0; z1=5*R; dz=(z1-z0)/NZ;
        zmax=R/math.sqrt(2);
        print ("1. R=",R)
        print (" E(R)=",f(R))
        print ("2. z=",0)
        print (" E(0)=",f(0))
        print ("3. zmax=",zmax)
        print (" Emax=",f(zmax))
        z=[]; E=[]
        z.append(0); E.append(0)
        for i in range(1,NZ):
          z2=z0+i*dz
          z.append(z2)
          E.append(f(z2))
        plt.plot(z,E,'k-')
        plt.xlabel('$z$',fontsize=20)
        plt.ylabel('$E$',fontsize=20)
        plt.show()
        `,
        languages: "python",
        container_id: 1,
        img1: `1-мысал.gif`,
        img2: `Снимок экрана (1058).png`,
    },
    {
        task_id: "2",
        content_title: `Өріс Е кернеулігі z осінің бойымен бағытталған (3-сурет), яғни  E = Ez , dE=kdE, dE= k0σdSr/r3 , мұнда 
        r2 = (zk-R)2 = z2 + R2 , dS = 2πRdR,
        kr = z, dE= k0σ2πRdRz/(R2 +z2)3/2
        0-ден R –ге дейін интегралдап келесі өрнекті аламыз
        немесе
        Электр өрісінің кернеулілігінің максималь мәнін dE/dz =0 шарты бойынша анықтаймыз  
        яғни экстремум жоқ, Ez функциясы монотонды түрде төмендейді, демек z = 0 болған кезде, Е максималды мәніне жетеді.
            Зарядталған дискіден орын алған электростатикалық өрістің кернеулігін есептейтін программа құрайық.
        `,
        id_faq: "faq_2",
        for_faq: "faq_2",
        question: `Радиусы R = 0.1 м     жұқа бір текті диск                             σ = 1.0 мкКл/м2  беттік тығыздықпен біркелкі зарядталып горизонталь орналасқан.
        Өріс кернеулігін Е анықтаңыз: 1) диск центрі арқылы өтетін және оның жазықтығына перпендикуляр болып келетін, ось  бойымен z=0,1м қашықтықтағы өріс кернеулігін; 2) диск центріндегі кернеулікті; 3) симметрия осіндегі өріс кернеулігі диск центрінен қандай қашықтықта максималь мәнге ие болады? 4) минималь мәні ше?.
        `,
        img_url: heroImg,
        answers: `# диск өрісі
        import math
        import matplotlib.pyplot as plt
        eps0=8.85e-12; k0=1/(4*math.pi*eps0);
        NZ=1000; R=0.1; sigma=1.0e-6;
        q=sigma*math.pi*R**2;
        def f(z):
            f=k0*q*(1-z/math.sqrt(R*R+z*z))/R**2;
            return f
        z0=0; z1=5*R; dz=(z1-z0)/NZ;
        print ("1. R=",R)
        print (" E(R)=",f(R))
        print ("2. z=",0)
        print (" E(0)=",f(0))
        z=[]; E=[];
        z.append(0); E.append(0);
        for i in range(1,NZ):
            z2=z0+i*dz
            z.append(z2)
            E.append(f(z2))
        plt.plot(z,E,'k-')
        plt.xlabel('$z$',fontsize=20)
        plt.ylabel('$E_z$',fontsize=20)
        plt.show()
        `,
        languages: "python",
        container_id: 2,
        img1: `2-мысал.gif`,
        img2: `Снимок экрана (1061).png`,
    },
    {
        task_id: "3",
        content_title: `(0, ±а) нүктесінде z=0 қилысатын жазықтық және z осіне параллель зарядталған жіптерден пайда болған электр өрісінің кернеулігін анықтайық. 


        мұнда R = xi + (y a)j, ал минус шексіздіктен плюс шексіздікке дейінгі интегралдың кестелік мәні келесі өрнекке тең болады:
        
        
        
         суперпозиция принципіне сәйкес қорытынды өрістің кернеулігі 
        
        
        
        y = 0 симметрия жазықтығында жіптен өрістің кернеулігі
        
        
        онда максимум шарты
        
        
        
        және   болған кезде  өріс кернеулігінің максималь мәні
          – тең болады.
        
         нольге ұмтылғанда өріс кернеулігі  болып өзгереді,  болған кезде, өріс кернеулігі   тең болады, ал   гиперболалық заң бойынша өріс кернеулігі нольге ұмтылады.
        
        Екі параллель зарядталған жіптерден пайда болған электр өрісінің кернеулігін есептейтін программа құрастырайық:
        `,
        id_faq: "faq_3",
        for_faq: "faq_3",
        question: `Әрқайсысының сызықтық тығыздығы  λ = 0,50 мкКл/м, екі ұзын параллель жіп біркелкі зарядталған. Олардың арасындағы қашықтық 2а = 0,45 м. Декарттық жүйедегі y және z осьтерінің координаталары жіпті қамтитын жазықтықтың бойында жатсын және  z осі олардан бірдей тең қашықтыққа алыстатылған. Электр өрісінің кернеулілігінің максималь мәнін анықтаңыз. z=0 жазықтығындағы электр өрісінің күш сызықтарын тұрғызыңыз.`,
        img_url: heroImg,
        answers: `# Екі жіптің өрісі
        import math
        import matplotlib.pyplot as plt
        eps0=8.85e-12; k0=1/(4*math.pi*eps0);
        a=0.225; lam=0.50e-6;
        NX=1000; x0=0;x2=5*a; dx=(x2-x0)/NX;
        def f(x):
            f=4*k0*lam*x/(x*x+a*a);
            return f
        x1=a;
        print (" x1 =",x1)
        print (" E(x1)=",f(x1))
        x=[]; Ex=[]
        x.append(0); Ex.append(f(0))
        for i in range(1,NX):
            x3=x0+i*dx
            x.append(x3)
            Ex.append(f(x3))
        plt.plot(x,Ex,'k-')
        plt.xlabel('$x$',fontsize=18)
        plt.ylabel('$E_x$',fontsize=18)
        plt.show()

        #z=0 жазықтықтағы екі жіп өрісінің өріс сызықтары
        import math as mt
        import matplotlib.pyplot as plt
        a=0.25; N1=50; N=1000; dr=0.005; b=4*a;
        dalp=2*mt.pi/N1; r0=10*dr; yb=[-a,a];
        xg=[];yg=[];
        for ya in yb:
            for j in range(0,N1):
                alp=j*dalp;
                x=r0*mt.cos(alp);
                y=ya+r0*mt.sin(alp);
                for i in range(1,N):
                    R1=x*x+(y+a)*(y+a);
                    R2=x*x+(y-a)*(y-a);
                    EX=x*(1/R1+1/R2);
                    EY=((y+a)/R1+(y-a)/R2);
                    E=mt.sqrt(EX*EX+EY*EY);
                    dx=dr*EX/E; dy=dr*EY/E;
                    x=x+dx; y=y+dy;
                    xg.append(x); yg.append(y);
        plt.scatter(xg,yg,s=0.25,c='k')
        plt.xlim(-b, b)
        plt.ylim(-b, b)
        plt.gca().set_aspect('equal', adjustable='box')
        plt.scatter(0,-a, s=10, c='k')
        plt.scatter(0, a, s=10, c='k')
        plt.xlabel('$x$',fontsize=16)
        plt.ylabel('$y$',fontsize=16)
        plt.show()
        `,
        languages: "python",
        container_id: 3,
        img1: `3-мысал.gif`,
        img2: `Снимок экрана (1064).png`,
    },
    {
        task_id: "3.1",
        content_title: `
        Программа листингісінде қатардың реттік номерлері тек қана программаны түсіндіру үшін енгізілген, программаның мәтіндерінде қатарларды номерлеу қолданылмайды. 
Программада 01 – түсініктеме; 02 - math математикалық функцияларды есептеу пакетін қосу; 03 - matplotlib.pyplot пакетін қосу; 04-05  алғашқы деректерді анықтау: а, N1 – күш сызықтарының саны, N – бір күш сызығындағы нүктелер саны, dr – күш сызықтарының бойындағы қадамның ұзындығы, b -  өріс сызықтарын шығаратын терезесінің жарты ені, dalp, r0 – сызықтың бастапқы полярлық координаталары, yb – y координатасы,  06 - {x}n , {y}n күш сызықтыры координаталарының  бірөлшемді массивтерін (тізімдерін) инициализациялау, 07-20 {x}n , {y}n массивтерін есептеу; 21-29 xn ,yn –өрістің күш сызықтарын шығару`,
        id_faq: "faq_3.1",
        for_faq: "faq_3.1",
        question: `Программа листингісінде қатардың реттік номерлері тек қана программаны түсіндіру үшін енгізілген, программаның мәтіндерінде қатарларды номерлеу қолданылмайды. 
        Программада 01 – түсініктеме; 02 - math математикалық функцияларды есептеу пакетін қосу; 03 - matplotlib.pyplot пакетін қосу; 04-05  алғашқы деректерді анықтау: `,
        img_url: heroImg,
        answers: `# Екі жіптің өрісі
        import math
        import matplotlib.pyplot as plt
        eps0=8.85e-12; k0=1/(4*math.pi*eps0);
        a=0.225; lam=0.50e-6;
        NX=1000; x0=0;x2=5*a; dx=(x2-x0)/NX;
        def f(x):
            f=4*k0*lam*x/(x*x+a*a);
            return f
        x1=a;
        print (" x1 =",x1)
        print (" E(x1)=",f(x1))
        x=[]; Ex=[]
        x.append(0); Ex.append(f(0))
        for i in range(1,NX):
            x3=x0+i*dx
            x.append(x3)
            Ex.append(f(x3))
        plt.plot(x,Ex,'k-')
        plt.xlabel('$x$',fontsize=18)
        plt.ylabel('$E_x$',fontsize=18)
        plt.show()

        #z=0 жазықтықтағы екі жіп өрісінің өріс сызықтары
        import math as mt
        import matplotlib.pyplot as plt
        a=0.25; N1=50; N=1000; dr=0.005; b=4*a;
        dalp=2*mt.pi/N1; r0=10*dr; yb=[-a,a];
        xg=[];yg=[];
        for ya in yb:
            for j in range(0,N1):
                alp=j*dalp;
                x=r0*mt.cos(alp);
                y=ya+r0*mt.sin(alp);
                for i in range(1,N):
                    R1=x*x+(y+a)*(y+a);
                    R2=x*x+(y-a)*(y-a);
                    EX=x*(1/R1+1/R2);
                    EY=((y+a)/R1+(y-a)/R2);
                    E=mt.sqrt(EX*EX+EY*EY);
                    dx=dr*EX/E; dy=dr*EY/E;
                    x=x+dx; y=y+dy;
                    xg.append(x); yg.append(y);
        plt.scatter(xg,yg,s=0.25,c='k')
        plt.xlim(-b, b)
        plt.ylim(-b, b)
        plt.gca().set_aspect('equal', adjustable='box')
        plt.scatter(0,-a, s=10, c='k')
        plt.scatter(0, a, s=10, c='k')
        plt.xlabel('$x$',fontsize=16)
        plt.ylabel('$y$',fontsize=16)
        plt.show()
        `,
        languages: "python",
        container_id: 3.1,
        img1: `3.1-мысал.gif`,
        img2: `Снимок экрана (1066).png`,
    },
    {
        task_id: "4",
        content_title: `Зарядталған шар өрісінің потенциалы келесі өрнек арқылы есептелінеді:



        r >R0  болған кезде зарядталған шардың потенциалы келесі өрнекке тең болады:
        
        ⦁	Шардың берілген беттік тығыздығы үшін r  нүктесіндегі өріс потенциалы
        
        б) Берілген шардың φ(R0) потенциалы үшін r1 нүктедегі өріс потенциалын потенциалдар қатынасынан анықтауға болады:
        `,
        id_faq: "faq_4",
        for_faq: "faq_4",
        question: `Радиусы  R0 = 0.01м зарядталған шардың центрінен r1 =0,10 м қашықтықта орналасқан өрістің r нүктесіндегі φ потенциалын анықтаңыз. Егер:
        а) зарядтың беттік тығыздығы берілген, σ = 10,0 мкКл/м2 ;
        б) шардың потенциалы берілген, φ(R0) = 300 B  болса есепті қалай шешуге болады?
        `,
        img_url: heroImg,
        answers: `#Зариядталған шардың потенциялы
        import math as mt
        k0=9.0e9; sigma=1.0e-5; R0=0.01; r1=0.1; ph0=300.0
        ph1=k0*4*mt.pi*R0*R0*sigma/r1
        ph2=ph0*R0/r1;
        print('ph1=',ph1)
        print('ph2=',ph2)
        `,
        languages: "python",
        container_id: 4,
        img1: `Снимок экрана (1068).png`,
        img2: ``,
    },
    {
        task_id: "5",
        content_title: `Сақиналар центрі z осінің бойында жатсын және координаталар басын төменгі сақинаның центріне орнатайық.
        n-ші сақинаның А нүктесіндегі потенциалы φn(rn) – келесі өрнекке тең
        
        
        Мұнда n=1,2,   Xn = Rn cosα,   Yn =Rnsinα,   Z1 =0  немесе  Z2 = h,  λn – зарядтың сызықтық тығыздығы.
        Жоғарыдағы кез келген еркін А нүктесі үшін сандық түрде есептеу ыңғайлы, ол үшін тік төртбұрыштың квадраттық формуласын қолданамыз:
        
        
        мұнда         
        Екі сақинадан потенциалды есептеу үшін суперпозиция принципін қолданамыз:
        
        Егер осы принципті қолдансақ, онда n-ші сақинаның (xn=yn=0) осіндегі потенциалдың мәні  келесі өрнекпен анықталады:
        
        Потенциалдар айырымы     
        `,
        id_faq: "faq_5",
        for_faq: "faq_5",
        question: `Осьтері бір бірімен сәйкес келетін, радиусы R –ге тең екі жіңішке сақина бар болсын (8-сурет). Сақиналардың зарядтары q-ге және 
        -q –ге тең. Егер R=0.30 см және q=0.40 мкКл болса,  бірі-бірінен h=0.52 см қашықтықта орналасқан, сақиналар центрінің арасындағы потенциалдар айырымы қандай болады. 
       `,
        img_url: heroImg,
        answers: `# Сақиналар центрі арасындағы потенциялдар айырымы
        import math as mt
        k0=9.0e9;R=0.3; h=0.52;q=4.0e-7;
        Dph=2*k0*q*(1/R-1/mt.sqrt(R*R+h*h));
        print('Dph=',Dph)

        #Эквипотенциал бетінің y=0 жазықтығымен қимасы
        import numpy as np
        import matplotlib.pyplot as plt
        import numpy as mt
        k0=9.0e9;R=0.3; h=0.52;q=4.0e-7;NP=200;N=100;
        Dph=2*k0*q*(1/R-1/mt.sqrt(R*R+h*h));
        da=2*np.pi/NP; D1=k0*q/2/np.pi; D2=-D1;
        xmin=-1.5*R; xmax=1.5*R; zmin=-0.5*R; zmax=h+0.5*R;
        xl=np.linspace(xmin,xmax,N);
        zl=np.linspace(zmin,zmax,N);
        X,Z=np.meshgrid(xl,zl);
        A=X**2+Z**2+R*R; B=2*R*X; s=0;
        for i in range(0,NP):
            alp=i*da;
            s=s+1./np.sqrt(A-B*np.cos(alp));
        ph=D1*da*s;
        A=X**2+(Z-h)**2+R*R; s=0;
        for i in range(0,NP):
            alp=i*da;
            s=s+1./np.sqrt(A-B*np.cos(alp));
        ph=ph+D2*da*s;
        print("np.pi=",np.pi)
        print("dhp=",Dph/1000,"kB")
        plt.gca().set_aspect('equal', adjustable='box')
        cs=plt.contour(ph,40,colors='k',linewidths=2);
        plt.clabel(cs,fmt='%6.0f');
        plt.text(48,14,r'0',fontsize=16)
        plt.text(48,82,r'H',fontsize=16)
        plt.xlabel('$x$',fontsize=16)
        plt.ylabel('$z$',fontsize=16)
        plt.show()

        `,
        languages: "python",
        container_id: 5,
        img1: `Снимок экрана (1075).png`,
        img2: ``,
    },
    {
        task_id: "6",
        content_title: `Сақиналар центрі z осінің бойында жатсын және координаталар басын төменгі сақинаның центріне орнатайық.
        n-ші сақинаның А нүктесіндегі потенциалы φn(rn) – келесі өрнекке тең
        
        
        Мұнда n=1,2,   Xn = Rn cosα,   Yn =Rnsinα,   Z1 =0  немесе  Z2 = h,  λn – зарядтың сызықтық тығыздығы.
        Жоғарыдағы кез келген еркін А нүктесі үшін сандық түрде есептеу ыңғайлы, ол үшін тік төртбұрыштың квадраттық формуласын қолданамыз:
        
        
        мұнда         
        Екі сақинадан потенциалды есептеу үшін суперпозиция принципін қолданамыз:
        
        Егер осы принципті қолдансақ, онда n-ші сақинаның (xn=yn=0) осіндегі потенциалдың мәні  келесі өрнекпен анықталады:
        
        Потенциалдар айырымы     
        `,
        id_faq: "faq_6",
        for_faq: "faq_6",
        question: `Осьтері бір бірімен сәйкес келетін, радиусы R –ге тең екі жіңішке сақина бар болсын (8-сурет). Сақиналардың зарядтары q-ге және 
        -q –ге тең. Егер R=0.30 см және q=0.40 мкКл болса,  бірі-бірінен h=0.52 см қашықтықта орналасқан, сақиналар центрінің арасындағы потенциалдар айырымы қандай болады. 
       `,
        img_url: heroImg,
        answers: `# Сақиналар центрі арасындағы потенциялдар айырымы
        import math as mt
        k0=9.0e9;R=0.3; h=0.52;q=4.0e-7;
        Dph=2*k0*q*(1/R-1/mt.sqrt(R*R+h*h));
        print('Dph=',Dph)
        `,
        languages: "python",
        container_id: 6,
        img1: `Снимок экрана (1074).png`,
        img2: ``,
    },
    {
        task_id: "6.1",
        content_title: `Сақиналар центрі z осінің бойында жатсын және координаталар басын төменгі сақинаның центріне орнатайық.
        n-ші сақинаның А нүктесіндегі потенциалы φn(rn) – келесі өрнекке тең
        
        
        Мұнда n=1,2,   Xn = Rn cosα,   Yn =Rnsinα,   Z1 =0  немесе  Z2 = h,  λn – зарядтың сызықтық тығыздығы.
        Жоғарыдағы кез келген еркін А нүктесі үшін сандық түрде есептеу ыңғайлы, ол үшін тік төртбұрыштың квадраттық формуласын қолданамыз:
        
        
        мұнда         
        Екі сақинадан потенциалды есептеу үшін суперпозиция принципін қолданамыз:
        
        Егер осы принципті қолдансақ, онда n-ші сақинаның (xn=yn=0) осіндегі потенциалдың мәні  келесі өрнекпен анықталады:
        
        Потенциалдар айырымы     `,
        id_faq: "faq_6.1",
        for_faq: "faq_6.1",
        question: `Осьтері бір бірімен сәйкес келетін, радиусы R –ге тең екі жіңішке сақина бар болсын (8-сурет). Сақиналардың зарядтары q-ге және 
        -q –ге тең. Егер R=0.30 см және q=0.40 мкКл болса,  бірі-бірінен h=0.52 см қашықтықта орналасқан, сақиналар центрінің арасындағы потенциалдар айырымы қандай болады. 
       `,
        img_url: heroImg,
        answers: `#Эквипотенциал бетінің y=0 жазықтығымен қимасы
        import numpy as np
        import matplotlib.pyplot as plt
        import numpy as mt
        k0=9.0e9;R=0.3; h=0.52;q=4.0e-7;NP=200;N=100;
        Dph=2*k0*q*(1/R-1/mt.sqrt(R*R+h*h));
        da=2*np.pi/NP; D1=k0*q/2/np.pi; D2=-D1;
        xmin=-1.5*R; xmax=1.5*R; zmin=-0.5*R; zmax=h+0.5*R;
        xl=np.linspace(xmin,xmax,N);
        zl=np.linspace(zmin,zmax,N);
        X,Z=np.meshgrid(xl,zl);
        A=X**2+Z**2+R*R; B=2*R*X; s=0;
        for i in range(0,NP):
            alp=i*da;
            s=s+1./np.sqrt(A-B*np.cos(alp));
        ph=D1*da*s;
        A=X**2+(Z-h)**2+R*R; s=0;
        for i in range(0,NP):
            alp=i*da;
            s=s+1./np.sqrt(A-B*np.cos(alp));
        ph=ph+D2*da*s;
        print("np.pi=",np.pi)
        print("dhp=",Dph/1000,"kB")
        plt.gca().set_aspect('equal', adjustable='box')
        cs=plt.contour(ph,40,colors='k',linewidths=2);
        plt.clabel(cs,fmt='%6.0f');
        plt.text(48,14,r'0',fontsize=16)
        plt.text(48,82,r'H',fontsize=16)
        plt.xlabel('$x$',fontsize=16)
        plt.ylabel('$z$',fontsize=16)
        plt.show()
        
        `,
        languages: "python",
        container_id: 6.1,
        img1: `6.1-мысал.gif`,
        img2: `Снимок экрана (1073).png`,
    },
    {
        task_id: "7",
        content_title: `Зарядталған метал шар  өрісінің кернеулігі      өрнегімен есептелінеді, онда максималь кернеулікті келесі түрде жаза аламыз:   , осы өрнектен  qmax –ды анықтайыз.       .Есептің шартында берілген екі жағдайға сәйкес, qmax –ды есептеу қортындысын келтірейік: ⦁	qmax1= 1.1 пКл;
        ⦁	qmax2= 110 пКл.
        `,
        id_faq: "faq_7",
        for_faq: "faq_7",
        question: `Егер құрғақ ауада электр өрісінің кернеулігі 1 МВ/м –ден үлкен болса, онда иондар түзіліп, ұшқын разрядтар пайда болады. Радиусы 1) R1 =0.01 см және 2) R2 =0.10 см   метал сфераға қандай максималь электр зарядын беруге болады. 
        `,
        img_url: heroImg,
        answers: `#Зарядталған шардың кернеулігі
        k0=9.0e9; R1=1.0e-4; R2=1.0e-3; Emax=1.0e6;
        qmax1=Emax*R1*R1/k0; qmax2=Emax*R2*R2/k0;
        print('qmax1=',qmax1)
        print('qmax2=',qmax2)
        `,
        languages: "python",
        container_id: 7,
        img1: `Снимок экрана (1073).png`,
        img2: ``,
    },
    {
        task_id: "8",
        content_title: `Гаусс теоремасын қолданамыз. Гаусс теоремасының интегральдық формасы 



        Теңдеудің оң жағы ε0 ε – ге бөлінген  сфералық беттің ішінде орналасқан зарядтың шамасын береді.
        а) r<R1  және  q=0, онда  жоғарғы өрнектегі E=0 болады;
        б) R1 < r < R2 ,
        
        
        Гаусс теоремасы бойынша    осыдан 
        
        в)  r > R2 ,
        
        
        Теорема бойынша 
        `,
        id_faq: "faq_8",
        for_faq: "faq_8",
        question: `R1 =0.01 см және R2 =0.02 см   екі концентрлі сферада,  σ1 = 1,0 нКл/м2  және σ2 = -0,5 нКл/м2 беттік тығыздықпен зарядтар бірқалыпты тарамдалған. Сфераның центрінен r1 =1,5 см және r2 =3,0 см  ара қашықтықта рналасқан нүктедегі электр өрісінің Е кернеулігін анықтаңыз. Сфералардың арасындағы кеңістік  диэлектрлік өтімділігі ε = 10 шынымен толтырылған.`,
        img_url: heroImg,
        answers: `#Концентірлі шарлар
        import math as mt
        import matplotlib.pyplot as plt
        eps0=8.85e-12; k0=9.0e9;eps1=10; eps2=1;
        R1=0.01; R2=0.02; r1=0.015; r2=0.03;
        sigma1=1.0e-9; sigma2=-0.5e-9;
        q1=4*mt.pi*R1*R1*sigma1; q2=4*mt.pi*R2*R2*sigma2;
        E1=k0*q1/(eps1*r1*r1); E2=k0*(q1+q2)/(eps2*r2*r2);
        print('E1=',E1,'\n E2=',E2)
        NR=5000; Rmin=0; Rmax=0.05; dR=(Rmax-Rmin)/NR;
        r=[]; E=[];
        r.append(0);
        E.append(0);
        for i in range(1,NR):
            rr=Rmin+i*dR;
            if rr<R1:
                E.append(0);
            elif rr<R2:\
                E.append(k0*q1/(eps1*rr*rr));
            else:
                E.append(k0*(q1+q2)/(eps2*rr*rr));
            r.append(rr);
        plt.plot(r,E,'k-',linewidth=2.0)
        plt.plot([r1,r1], [-30,15], 'k--')
        plt.plot([r2,r2], [-30,15], 'k--')
        plt.grid(True)
        plt.xlabel('$r$',fontsize=16)
        plt.ylabel('$E$',fontsize=16)
        plt.show()
        `,
        languages: "python",
        container_id: 8,
        img1: `Снимок экрана (1077).png`,
        img2: ``,
    },
    {
        task_id: "9",
        content_title: `l >> r1 , r2 ұзын коаксиальды түтіктердің маңында, мұнда  l -  түтіктердің ұзындығы, түтіктердің ұштарынан алыстау жерде электр өрісі кернеуліктерінің күш сызықтары түтіктер осіне перпендикуляр болады. 
        Осі түтіктің осімен сәйкес келетін, радиусы r-ге және ұзындығы l –ге тең болатын тұйық цилиндрлік беті арқылы өтетін D индукция векторының ағынын келесі өрнекпен анықтай аламыз:
        
        Мұнда S1 – төменгі табаны; S2 – жоғарғы табаны; S3 – цилиндрдің беті. S1  және S2 арқылы өтетін D ағынының шамасы нольге тең, себебі өзара перпендикуляр векторлардың DdS скалярлық көбейтіндісі нольге тең. Олай болса: 
        
         
        Гаусс теоремасы бойынша   . Үш жағдайды қарастырамыз:
        `,
        id_faq: "faq_9",
        for_faq: "faq_9",
        question: `Радиустары  R1 = 0.02 м және R2  = 0.04 м болатын екі ұзын жұқа қабырғалы  коаксиальды  түтіктер, түтіктердің ұзындық бірлігіне келетін зарядтар шамасы λ1 =1нКл/м және λ2 =0,5 нКл/м  болатын беттік зарядпен біркелкі зарядталған. Түтіктер осінен r1 = 3 см және r2  = 5 см қашықтықта орналасқан нүктедегі электр өрісінің кернеулігін анықтаңыз.`,
        img_url: heroImg,
        answers: `# Коаксиалды түтік
        import matplotlib.pyplot as plt
        eps0=8.85e-12; k0=9.0e9;eps1=6.5; eps2=1;
        R1=0.02; R2=0.04; r1=0.03; r2=0.05;
        lam1=1.0e-9; lam2=0.5e-9;
        q1=lam1*R1/eps0; q2=lam2*R2/eps0;
        E1=q1/(eps1*r1); E2=(q1+q2)/(eps2*r2);
        print('E1=',E1,'\n E2=',E2)
        NR=5000; Rmin=0; Rmax=0.1; dR=(Rmax-Rmin)/NR;
        r=[]; E=[];
        r.append(0); E.append(0);
        for i in range(1,NR):
            rr=Rmin+i*dR;
            if rr<R1:
                E.append(0);
            elif rr<R2:
                E.append(q1/(eps1*rr));
            else:
                E.append((q1+q2)/(eps2*rr));
            r.append(rr);
        plt.plot(r,E,'k-',linewidth=2.0)
        plt.plot([R1,R1], [0,120], 'k-.')
        plt.plot([R2,R2], [0,120], 'k-.')
        plt.plot([r1,r1], [0,120], 'k--')
        plt.plot([r2,r2], [0,120], 'k--')
        plt.grid(True)
        plt.xlabel('$r$',fontsize=16)
        plt.ylabel('$E$',fontsize=16)
        plt.show()
        `,
        languages: "python",
        container_id: 9,
        img1: `Снимок экрана (1082).png`,
        img2: ``,
    },
    {
        task_id: "10",
        content_title: `Диэлектриктің поляризациясын     өрнегімен анықтаймыз. Бұл өрнектен   .
        Р – ны есепетейтін программа құралық:
        `,
        id_faq: "faq_10",
        for_faq: "faq_10",
        question: `Кернеулігі  E0 = 20 кВ/м –ге тең сыртқы электр өрісіне диэлекрикті орналастырайық. Егер диэлектриктің орташа макроскопикалық өрісінің кернеулігі 4 кВ/м –ге тең болса, онда диэлектриктің поляризациясы қандай мәнге ие бола алады?
        `,
        img_url: heroImg,
        answers: `#Диэлектірлік поляризация 1
        eps0=8.85e-12; E0=2.0e4; E=4.0e3;
        P=eps0*(E0-E);
        print('P=',P)
        `,
        languages: "python",
        container_id: 10,
        img1: `Снимок экрана (1083).png`,
        img2: ``,
    },
    {
        task_id: "11",
        content_title: `Мосотти моделі бойынша жеке электрленген өткізгіш шарик түріндегі, сыртқы электр өрісінде поляризацияланатын және дипольдік моментке ие болатын, бөлшекті қарастыралық. Аргон атомының поляризациялануын   теңдеуінен анықтаймыз. 
        Қалыпты жағдайда  газтәрізді аргонның концентрациясын газдардың кинетикалық теориясының негізгі теңдеуінен анықтаймыз:
        
        Осыдан    .
        
        Клаузиус-Мосотти теңдеуінен сұйық және қатты күйдегі аргонның диэлектрлік өтімділігін анықтаймыз:
        `,
        id_faq: "faq_11",
        for_faq: "faq_11",
        question: `Қалыпты жағдайда газтәріздес аргонның диэлектрлік қабылдағыштығы 
        χ  = 5,54*10-4. Сұйық күйдегі  және қатты күйдегі аргонның  және  диэлектрлік өтімділігін анықтаңыздар. Аргонның молярлық массасы  . Аргонның сұйық күйдегі тығыздығы   және қатты күйдегі тығыздығы  .
        `,
        img_url: heroImg,
        answers: `# Диэлектрлік поляризация 2
        eps0=8.85e-12;k=1.38e-23;p0=1.0e5;T0=273;NA=6.02e23;
        chi=5.54e-4; ro1=1400; ro2=1650; mu=0.040;
        n=p0/(k*T0); alp=3*chi/(n*(chi+3));
        eta1=alp*ro1*NA/3/mu; eta2=alp*ro2*NA/3/mu;
        eps1=(1+2*eta1)/(1-eta1); eps2=(1+2*eta2)/(1-eta2);
        print('n= ',n,'\nalp =',alp)
        print('eps1=',eps1,'\neps2=',eps2)
        `,
        languages: "python",
        container_id: 11,
        img1: `Снимок экрана (1083).png`,
        img2: ``,
    },
    {
        task_id: "12",
        content_title: `а)  Шыныдағы өрістің кернеулігі   –ға тең, ал басқа жағынан 


        б) конденсатордың астарларындағы зарядтың беттік тығыздығы: 
        
        в) шыныдағы байланысқан зарядтардың   σ’  беттік тығыздығы. 
        
        г) шынының диэлектрлік χ  қабылдағыштығы`,
        id_faq: "faq_12",
        for_faq: "faq_12",
        question: `Жазық конденсатордың пластиналарының арасындағы кеңістік шынымен толтырылған. Конденсатор пластиналарының арасындағы қашықтық d=4 мм. Пластиналарға U=1200 В кернеу берілген. Табу керек: а) шыныдағы  Е электр өрісінің кернеулігін; б) конденсатордың астарларындағы               зарядтың σ беттік тығыздығын; в) шыныдағы байланысқан зарядтардың   σ’ беттік тығыздығын; г) шынының диэлектрлік χ  қабылдағыштығын.  Шынының диэлектрлік өтімділігі ε = 6.`,
        img_url: heroImg,
        answers: `#Диэлектриктердің поляризациясы 3
        eps0=8.85e-12; U=1200; d=4.0e-3; eps=6;
        E=U/d; sig=eps0*eps*E; sig1=(eps-1)*eps0*E;chi=eps-1;
        print('E =',E,'\nsig =',sig)
        print('sig1=',sig1,'\nchi =',chi)
        `,
        languages: "python",
        container_id: 12,
        img1: `Снимок экрана (1084) (1).png`,
        img2: ``,
    },
    {
        task_id: "13",
        content_title: `Пластиналар жазықтықтарына электр өрісінің күш сызықтары перпендикуляр, 

        мұнда j = 1, 2, 3, 4.
        Конденсаторда суретте көрсетілгендей үш ішкі бөлік бар: 31, 12,  24.
         
        
         ,
        
          ,
        
         , 
        сонымен:      
        Диэлектрлік қабаттардың поляризациясы: 
        
        1 - ші пластинаның бетіндегі байланысқан зарядтардың беттік тығыздығы:
        
        2 - ші пластинаның бетіндегі байланысқан зарядтардың беттік тығыздығы:
        
        Диэлектриктер бөлігінің шекарасындағы байланысқан зарядтардың беттік тығыздығы:              
        `,
        id_faq: "faq_13",
        for_faq: "faq_13",
        question: `Жазық конденсатордың астарларының арасында диэлектрлік өтімділігі 
        ε1 = 3.7  парафиндік қағаздан  және  ε2 = 6,0 слюдадан жасалған екі бір –біріне іргелес жатқан диэлектрлік пластиналар орналасқан. Конденсатордың әрбір пластиналарында σ = ± 10-8 Кл/м2 беттік тығыздықпен заряд таралған. Диэлектриктік пластиналардың еркін беттеріндегі және бөлік шекарасындағы байланысқан зарядтардың тығыздығын анықтаңыздар. Конденсатордың астарларының арасындағы толықтырылмаған кеңістіктегі диэлектриктік өтімділігі ε3 = ε4 = 1 – ге тең.   
        `,
        img_url: heroImg,
        answers: `# Диэлектриктердің поляризациясы 4
        eps1=3.7; eps2=6; eps3=1;eps4=1; s=1.0e-8;
        sigma1=-(eps1-1)*s/eps1; sigma2=(eps2-1)*s/eps2;
        sigma12=s*(1/eps2-1/eps1);
        print('sigma1 =',sigma1,'\nsigma2 =',sigma2)
        print('sigma12=',sigma12)
        `,
        languages: "python",
        container_id: 13,
        img1: `Снимок экрана (1086).png`,
        img2: ``,
    },
    {
        task_id: "14",
        content_title: `Байланысқан зарядтардың беттік тығыздығы     өрнегімен анықталады (зарядтың таңбасы сферадағы зарядтың таңбасына қарама қарсы). Өрістің күш сызықтары радиальды, сондықтан   . Ішкі беттегі байланысқан зарядтардың беттік тығыздығы   .  
        Сыртқы  беттегі байланысқан зарядтардың беттік тығыздығы   .  
        Фарфор қабатының ішкі және сыртқы жағындағы зарядты есептейміз және оларды салыстырамыз:
        `,
        id_faq: "faq_14",
        for_faq: "faq_14",
        question: `Радиусы  металл шар қалыңдығы   фарфор қабатымен біркелкі қапталған. Сыртқы радиусы   Диэлектриктің ішкі және сыртқы беттеріндегі сәйкес    байланысқан электрлік зарядтардың беттік тығыздығын анықтаңыздар. Шардың заряды q=10 нКл, ал фарфордың диэлектрлік 
        өтімділігі ε =5.
        
        `,
        img_url: heroImg,
        answers: `# Диэлектрірлік поляризация 5
        import math as mt
        eps2=5; R1=0.05; R2=0.07; q=1.0e-8;
        sigma1=-(eps2-1)*q/(4*mt.pi*R1*R1);
        sigma2= (eps2-1)*q/(4*mt.pi*R2*R2);
        q1=4*mt.pi*R1*R1*sigma1;
        q2=4*mt.pi*R2*R2*sigma2;
        print('sigma1 =',sigma1,'\nsigma2 =',sigma2)
        print('q1 =',q1,'\nq2 =',q2) 
        `,
        languages: "python",
        container_id: 14,
        img1: `Снимок экрана (1087).png`,
        img2: ``,
    },
    {
        task_id: "15",
        content_title: `Әр түрлі таңбалы зарядтармен зарядталған жазықтықтар арасындағы өрістің кернеулігі   =     өрнегімен анықталады.  Потенциальдар айырымын сыналатын    зарядын бір пластинадан екіншісіне орын ауыстырған кезде жасалатын   жұмыстың анықтамасынан табамыз:

        Ізделініп отырған потенциальдар айырмасы келесі өонекке тең:
        `,
        id_faq: "faq_15",
        for_faq: "faq_15",
        question: `Екі шексіз параллель жазықтық бір-бірінен d=0.5 см қашықтықта орналасқан. Жақтықтарда  және   беттік тығыздықпен зарядтар таралған. Жазықтықтар арасындағы   φ потенциальдар айырымын анықтаңыздар. `,
        img_url: heroImg,
        answers: `# Эелектр өрісіндегі өткізгіш 1
        eps0=8.85e-12; d=0.005; s1=2.0e-7; s2=-3.0e-7;
        U=(s1+abs(s2))*d/2/eps0;
        print('U =',U)
        `,
        languages: "python",
        container_id: 15,
        img1: `Снимок экрана (1088).png`,
        img2: ``,
    },
    {
        task_id: "16",
        content_title: `Біз жаңбыр тамшыларының өлшемі 0,1-ден 5 мм-ге дейінгі диапазонда болатынын білеміз. Бұлтта судың қату температурасынан жоғары температурада бұлттың ұсақ тамшыларының бірігу процесі, ақырында бұлттан тамшылардың құлап түсуіне әкеп соғады. Әрбір жаңбыр тамшысының электр заряды бар, сондықтан тамшының бетіндегі потенциаль нольге тең емес және оны келесі өрнекпен анықтаймыз:

        N жаңбыр тамшылары біріккен кезде, үлкен тамшының қортынды заряды  
        Егер алғашқы тамшылар өлшемі шамамен бірдей болса, онда
        `,
        id_faq: "faq_16",
        for_faq: "faq_16",
        question: ` сегіз жаңбыр тамшысы бір жаңбыр тамшысына бірігеді. Үлкен тамшының    потенциалын  анықтыңыз. `,
        img_url: heroImg,
        answers: `# Жаңбыр тамшыларын біріктіру 2
        k0=9.0e9; R1=0.001; N=8; q1=0.1e-9; ph1=k0*q1/R1;
        qN=N*q1; RN=N**(1/3)*R1; phN=k0*qN/RN;
        print('ph1=',ph1,'\nphN =',phN)
        `,
        languages: "python",
        container_id: 16,
        img1: `Снимок экрана (1089).png`,
        img2: ``,
    },
    {
        task_id: "17",
        content_title: `Шариктерді бір біріне жалғағанға дейін шариктердің бетіндегі потенциаль, сыйымдылығы және зарядтары әр түрлі. Шариктерді өткізгішпен жалғастырған кезде, зарядтар бірінші шариктен екіншісіне ағып өтеді, яғни бұл зарядтардың ағысы шариктердің потенциальдары толығымен теңескен кезде тоқтайды    Ақырғы күйінде бірінші шариктің электрлік заряды   , ал екіншісінікі - . Зарядтардың шамасын анықтаймыз. 


        Электрлік зарядтардың сақталу заңынан    .
        Олай болса: 
        
        Осыдан 
        
        Бірінші шариктің заряды   
        
        Екінші шариктің заряды    
        `,
        id_faq: "faq_17",
        for_faq: "faq_17",
        question: `Бірінші шарикке      екінші шарикке      заряд берілген, сосын ол шарларды өткізгішпен жалғаған. Бір бірінен алыс қашықтықта орналасқан шариктердегі зарядтардың ақырғы таралуын анықтаңыздар. Бірінші шариктің радиусы   ,  ал екіншісінікі  . Жалғастыруға қолданған өткізгіштердің сыйымдылығын ескермеуге болады. `,
        img_url: heroImg,
        answers: `#Екі шар
        import math as mt
        eps0=8.85e-12;R1=0.08;R2=0.16;q1=12.0e-9;q2=18.0e-9;
        C1=4*mt.pi*eps0*R1; C2=4*mt.pi*eps0*R2;
        ph=(q1+q2)/(C1+C2); Q1=C1*ph; Q2=C2*ph;
        print('Q1=',Q1,'\nQ2 =',Q2)
        print('q1+q2=',q1+q2,'\nQ1+Q2 =',Q1+Q2)
        `,
        languages: "python",
        container_id: 17,
        img1: `Снимок экрана (1090).png`,
        img2: ``,
    },
    {
        task_id: "18",
        content_title: `Есептің шарты бойынша берілген конденсатор батареясының сыйымдылығы  
        Әрбір қабаттағы электр өрісінің кернеулігі 
        
        Диэлектриктің бірінші қабатындағы электрлік индукция 
        
        Диэлектриктің екінші қабатындағы электрлік индукция 
        
        Бірінші қабаттағы потенциальдың кемуі   , ал екінші қабаттағы потенциальдың кемуі   . 
        `,
        id_faq: "faq_18",
        for_faq: "faq_18",
        question: `Екі диэлектрлік қабат U=600 B  потенциальдар айырымына дейін зарядталған жазық конденсатордың пластиналарының арасында орналасқан: шынының қалыңдығы d1  = 7 мм және эбониттің қалыңдығы d2 = 3 мм. Әрбір пластинаның ауданы S =200 см2. Табу керек: а) конденсатордың С сыйымдылығын; б) әрбір қабаттағы  электрлік өрістің  E1, E2 кернеулігін D1, D2 электрлік индукциясын және U1, U1 потенциальдың кемуін анықтаңыздар. `,
        img_url: heroImg,
        answers: `#Диэлектриктің екі қабаты
        eps0=8.85e-12; eps1=7; eps2=3;
        S=0.02; d1=0.007; d2=0.003;U=600;
        C1=eps0*eps1*S/d1; C2=eps0*eps2*S/d2;
        C=C1*C2/(C1+C2);
        s=C*U/S; E1=s/eps0/eps1; E2=s/eps0/eps2;
        D=s; U1=E1*d1; U2=E2*d2;
        print('C =',C,'\nE1 =',E1,' E2=',E2)
        print('D=',s,'\nU1 =',U2,' U2=',U2)
        `,
        languages: "python",
        container_id: 18,
        img1: `Снимок экрана (1092).png`,
        img2: ``,
    },
    {
        task_id: "19",
        content_title: `Конденсатордағы бастапқы өріс энергиясы  /2 өрнегімен анықталады. Екінші конденсаторды параллель жалғағаннан кейін оның энергиясы келесі өрнекпен есептелінеді:   . Потенциальдар  Um айырымын электрлік зарядтардың сақталу заңынан анықтаймыз. 



        Ұшқыннан пайда болған энергия    
        `,
        id_faq: "faq_19",
        for_faq: "faq_19",
        question: `Электрсыйымдылығы C1 = 680 пФ конденсаторды U1=1.5 кВ потенциальдар айырымына дейін зарядтап, ток көзінен айырды. Содан соң конденсаторға зарядталмаған сыйымдылығы C2 =470 пФ конденсаторды параллель жалғады. Конденсаторларды қосқан кезде олардың астарларының арасынан өтетін ұшқынның пайда болуына жұмсалған энергияны анықтаңыз.`,
        img_url: heroImg,
        answers: `# Ұшқын энергиясы
        C1=6.8e-10; C2=4.7e-10; U1=1500;
        C=C1+C2; W1=C1*U1*U1/2; Um=C1*U1/C;
        W2=C*Um*Um/2; DW=W1-W2;
        print('Um=',Um,'\nDW =',DW)
        `,
        languages: "python",
        container_id: 19,
        img1: `Снимок экрана (1093).png`,
        img2: ``,
    },
    {
        task_id: "20",
        content_title: `Өріс энергиясын анықтау үшін энергияның көлемдік  ω тығыздығы арқылы dW энергиясының анықтамасын пайдаланамыз. dW = ω dV. Электр өрісінің сфералық симметриясын ескере отырып, dV көлем элементін шар тәріздес қабат түрінде       қарастыруға болады. Олай болса барлық қабаттың энергиясы 


        Соңғы интегралды есептейміз және    өрнегін аламыз.
        `,
        id_faq: "faq_20",
        for_faq: "faq_20",
        question: ` бірқалыпты зарядталған сфераның маңайында электр өрісі жасақталған. Сфераның бетімен және   радиусы сфераның радиусынан екі есе үлкен, онымен концентрлі  болатын сфералық  бетпен шектелген өрістің энергиясы  қандай `,
        img_url: heroImg,
        answers: `# Қабат энергиясы
        k0=9.0e9; q=1.0e-7; R1=0.1; R2=0.2;
        W=0.5*k0*q*q*(1/R1-1/R2);
        print('W=',W)
        `,
        languages: "python",
        container_id: 20,
        img1: `Снимок экрана (1094).png`,
        img2: ``,
    },
];


const Task = () => {

    return (
        <section>

            <Container className="taskmenu">
                {taskdata.map((item) => (
                    <TaskCard item={item} />
                ))}
            </Container>
        </section>
    );
};

export default Task;
